module.exports = __webpack_public_path__ + "img/drawer-login-banner-mobile.1700b56.png";